import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { trackAction } from '@/idv/utils';
import { ImgProcessorsContextProvider } from '../components/image-processors';
import { MissingPermissionsSheetProvider } from '../components/missing-permissions-sheet';
import { MachineProvider } from './components/machine-provider';
import Router from './pages/router';
import type { MachineContext } from './utils/state-machine';
type NonIdDocFlowProps = {
  initialContext: Pick<MachineContext, 'authToken' | 'device' | 'config' | 'requirement'>;
  onDone: () => void;
};
const NonIdDocFlow = t0 => {
  const $ = _c(11);
  const {
    initialContext,
    onDone
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== initialContext) {
    t2 = {
      ...initialContext,
      allowPdf: true
    };
    $[1] = initialContext;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onDone) {
    t3 = <ImgProcessorsContextProvider><Router onDone={onDone} /></ImgProcessorsContextProvider>;
    $[3] = onDone;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== initialContext.device || $[6] !== t3) {
    t4 = <MissingPermissionsSheetProvider device={initialContext.device}>{t3}</MissingPermissionsSheetProvider>;
    $[5] = initialContext.device;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <MachineProvider args={t2}>{t4}</MachineProvider>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default NonIdDocFlow;
function _temp() {
  trackAction("non-id-doc:started");
}